<template>
  <div id="app" class="container">
    <div>
      <b-navbar type="dark" variant="info">
        <b-navbar-brand
          onclick="event.preventDefault()"
          :href="`#AP Data Extractor v${packageVersion}`"
        >
          <b-img class="" alt=" logo" center src="./assets/logo.png"></b-img>
        </b-navbar-brand>
        <b-navbar-brand> <h1>Data Extractor</h1></b-navbar-brand>
      </b-navbar>
    </div>
    <APIClient
      ref="client"
      :searchFieldsPayload="bundle.searchPayload"
      v-on:authSuccess="updateAuth"
      v-on:searchResults="updateSearchResults"
      v-on:savedSearches="updateSavedSearches"
    />

    <SearchConfiguration
      v-if="bundle.auth.logonData && bundle.auth.gTables && bundle.auth.gFields"
      ref="search"
      :clientBundle="bundle.auth"
      v-on:emitSearchPayload="searchFields"
      v-on:saveSearch="saveSearchObj"
      v-on:deleteSelectedSearch="deleteSearch"
      v-on:emitLoadSearch="updateSavedSearches"
    />

    <Reporter
      ref="report"
      :clientBundle="bundle.auth"
      :searchResults="bundle.searchResults"
      v-on:tableBusyStateChange="updateSearchButtonDirty"
    />
  </div>
</template>
<script>
import Reporter from "./components/Reporter.vue";
import APIClient from "./components/APIClient.vue";
import SearchConfiguration from "./components/SearchConfigs.vue";

export default {
  name: "App",
  components: {
    APIClient,
    SearchConfiguration,
    Reporter,
  },
  data() {
    return {
      bundle: {
        auth: {
          gFields: null,
          gTables: null,
          logonData: null,
          savedSearches: {
            list: {},
            guid: null,
            database: null,
            title: null,
            type: null,
          },
        },
        searchPayload: null,
        searchResults: {
          expectedRecords: null,
          data: null,
          headers: null,
          phrase: "",
        },
      },
    };
  },
  watch: {
    searchResults: {
      deep: true,
      handler: function () {
        const t = this,
          s = this.searchResults;
        if (s.data && s.expectedRecords) {
          if (s.data.length === s.expectedRecords) {
            t.$refs.search.runSearchButtonDirty = false;
          }
        }
      },
    },
  },
  created: function () {
    console.log("AP Data Extractor v" + process.env.PACKAGE_VERSION);
    window.document.title = "AP Data Extractor";
  },
  computed: {
    packageVersion: function () {
      return process.env.PACKAGE_VERSION;
    },
    queryParams: function () {
      let params = new URLSearchParams(`${window.location.search.substr(1)}`);
      return {
        reportType: params.get("report"),
        host: params.get("host"),
      };
    },
  },
  methods: {
    deleteSearch: function (searchObj, callback) {
      delete this.bundle.auth.savedSearches.list[searchObj.searchTitle];
      // this.$refs.client.pbDeleteContent(searchObj, this.$refs.client.pbList());
      this.$refs.client.pbSaveContent(callback);
    },
    saveSearchObj: function (searchObj) {
      //add search to saved search list
      console.log(searchObj);
      this.$refs.client.clientBundle.savedSearches.list[searchObj.searchTitle] =
        searchObj;
      //commit save to database
      this.$refs.client.pbSaveContent();
    },
    updateAuth: function (auth) {
      this.bundle.auth = auth;
      if (this.$refs.search)
        this.$refs.search.searchOptions.reportType =
          auth.serverType === "both" ? "ENPS" : auth.serverType;
    },
    searchFields: function (payload, callback) {
      this.$refs.client.pbSearchFields(payload, callback);
      this.bundle.searchResults.headers = payload[0].fieldsToReturnDict;
      this.bundle.searchResults.phrase = payload[0].searchPhrase;
    },
    updateSearchButtonDirty: function (buttonState) {
      this.$refs.search.runSearchButtonDirty = buttonState;
    },
    updateSearchResults: function (results) {
      const t = this;
      t.bundle.searchResults.data = results;
      if (t.$refs.search)
        t.$refs.search.searchResultCount = t.bundle.searchResults.data.length;
    },
    updateSavedSearches: function (savedSearches) {
      const t = this;
      if (savedSearches) {
        t.bundle.auth.savedSearches = savedSearches;
        if (t.$refs.search) {
          t.$refs.search.savedSearchOptions = savedSearches;
        }
      } else {
        t.$refs.client.pbList();
        // t.$refs.search.savedSearchOptions = t.bundle.auth.savedSearches;
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  max-width: 80%;
}
.fieldlist {
  background: rgb(212, 234, 237);
}
</style>

<style src="./components/css/vue-multiselect.min.css"></style>
